<i18n locale="en">
{
  "label": "Pro"
}
</i18n>
<template>
  <span class="upsell-gate-badge" data-testid="upsell-gate-badge">
    {{ text ?? t('label') }}
  </span>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

defineProps<{
  text?: string
}>()

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.upsell-gate-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16.8px;
  text-transform: uppercase;
  color: #dcf2f5;
  background-color: #2c2c2c;
  box-shadow:
    -2px 0 4px rgb(84 152 255 / 25%),
    2px 2px 4px rgb(123 255 138 / 25%),
    inset 0 -1px 2.7px rgb(255 255 255 / 41%);
}
</style>
